import React from "react";

export const InputTextArea = ({ value, onChange, title, idInput, numRows, placeholderText }) => {
    return (
        <label className="form-label">{title}
            <textarea className="form-control" id={idInput} rows={numRows} value={value} onChange={onChange} placeholder={placeholderText}></textarea>
        </label>

    );
}